import { auth } from '../../data-types/initialisation/initialisationConstants';
import { RESET_STATE } from '../types/stateTypes';
import {
  CLEAR_USER_DETAILS,
  SET_AUTHENTICATION,
  SET_GEO_LOCATION,
  SET_INBOX_BADGE,
  SET_LOADING_ACHIEVEMENTS,
  SET_LOCALE,
  SET_PENDING_QUESTIONS,
  SET_PROOF_REQUESTS,
  SET_SAFER_GAMBLING_QUESTIONS_SET,
  SET_SELECTED_PROOF_REQUEST,
  SET_TERMS_INFO,
  SET_USER_ACHIEVEMENTS,
  SET_USER_ACHIEVEMENTS_UPDATED,
  SET_USER_DETAILS,
  SET_USER_LOCATION,
  UserDataActionType,
  UserDataState,
} from '../types/userDataTypes';

export const initialUserDataState: UserDataState = {
  locale: undefined,
  userLocation: undefined,
  geoLocation: undefined,
  authentication: auth.UNAUTHENTICATED,
  user: {},
  terms: {
    accepted: true,
    newTerms: undefined,
  },
  inboxBadge: -1,
  proofRequests: [],
  selectedProofRequest: undefined,
  pendingQuestions: false,
  achievements: [],
  achievementsUpdated: false,
  loadingAchievements: false,
  saferGamblingQuestionsSet: undefined,
};

export const userDataReducer = (state = initialUserDataState, action: UserDataActionType): UserDataState => {
  switch (action.type) {
    case RESET_STATE:
      return {
        ...initialUserDataState,
      };
    case SET_LOCALE:
      return { ...state, locale: action.meta };
    case SET_AUTHENTICATION:
      return { ...state, authentication: action.meta.authentication };
    case SET_USER_DETAILS:
      return { ...state, user: action.meta };
    case SET_TERMS_INFO:
      return { ...state, terms: action.meta };
    case CLEAR_USER_DETAILS: {
      return { ...state, user: action.meta };
    }
    case SET_USER_LOCATION: {
      return { ...state, userLocation: action.meta };
    }
    case SET_GEO_LOCATION: {
      return { ...state, geoLocation: action.meta };
    }
    case SET_INBOX_BADGE: {
      return { ...state, inboxBadge: action.meta };
    }
    case SET_PROOF_REQUESTS: {
      return { ...state, proofRequests: action.meta };
    }
    case SET_SELECTED_PROOF_REQUEST: {
      return { ...state, selectedProofRequest: action.meta };
    }
    case SET_PENDING_QUESTIONS: {
      return { ...state, pendingQuestions: action.meta };
    }
    case SET_USER_ACHIEVEMENTS: {
      return { ...state, achievements: action.meta };
    }
    case SET_USER_ACHIEVEMENTS_UPDATED: {
      return { ...state, achievementsUpdated: action.meta };
    }
    case SET_LOADING_ACHIEVEMENTS: {
      return { ...state, loadingAchievements: action.meta };
    }
    case SET_SAFER_GAMBLING_QUESTIONS_SET: {
      return { ...state, saferGamblingQuestionsSet: action.meta };
    }
    default:
      return state;
  }
};
